import React from 'react';
import Modal from '../../components/Modals/Modal';
import SecondaryButton from '../../components/Buttons/SecondaryButton';
import PrimaryButton from '../../components/Buttons/PrimaryButton';

function RemoveCollaboratorModal({
  removeTreatmentCollaborator,
  showRemoveCollaborator,
  setShowRemoveCollaborator,
  selectedCollaborator,
  treatmentId,
}) {

  const handleCancelRemoveCollaborator = () => {
    setShowRemoveCollaborator(false);
  }

  const handleRemoveCollaborator = () => {
    removeTreatmentCollaborator({ treatmentId, collaboratorId:selectedCollaborator.id })
    setShowRemoveCollaborator(false);
  }

  return (
    <Modal title={'Remove Collaborator'} show={showRemoveCollaborator} hide={handleCancelRemoveCollaborator}>
      <div className='flex flex-col'>
        <div className='grid grid-cols-1 gap-y-1 my-8'>
          <span className='mb-2 text-center'>Are you sure you want to remove this collaborator</span>
        </div>
        <div className='grid grid-cols-2 gap-x-2'>
          <SecondaryButton onClick={handleCancelRemoveCollaborator} text='Cancel'/>
          <PrimaryButton text={'Remove'} onClick={handleRemoveCollaborator} />
        </div>
      </div>
    </Modal>
  )
}

export default RemoveCollaboratorModal